import { DashboardProps, DashboardPropsDefaults } from "../../types/dashboardProps.d";

const DashboardWidgetDirectorAlerts = ({ user }: DashboardProps): JSX.Element => {

    return (
        <>
            <div className={`${DashboardPropsDefaults.containerClassNames}`}>
                <div className="dashboard-widget-title pb-1">
                    <h3>Alerts</h3>
                </div>
                <div className={`${DashboardPropsDefaults.contentClassNames}`}>

                </div>
            </div>
        </>
    );
};

export default DashboardWidgetDirectorAlerts;
